import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Shield } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AffiliateLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/affiliates/login`, { email, password });
      localStorage.setItem('affiliate_token', res.data.access_token);
      localStorage.setItem('affiliate_user', JSON.stringify(res.data.affiliate));
      toast.success('Connexion réussie');
      navigate('/espace-partenaire');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="w-full max-w-sm p-6 sm:p-8" data-testid="affiliate-login-card">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-3">
            <Shield className="w-6 h-6 text-primary" />
          </div>
          <h1 className="text-xl sm:text-2xl font-semibold text-foreground" data-testid="affiliate-login-title">
            Espace Partenaire
          </h1>
          <p className="text-sm text-muted-foreground mt-1">Connectez-vous à votre compte</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1.5">Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="votre@email.ch"
              data-testid="affiliate-login-email"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1.5">Mot de passe</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Votre mot de passe"
              data-testid="affiliate-login-password"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-primary hover:bg-primary/90 text-primary-foreground h-11 font-semibold"
            data-testid="affiliate-login-submit"
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </Button>
        </form>

        <p className="text-center text-xs text-muted-foreground mt-4">
          Pas encore partenaire ?{' '}
          <Link to="/devenir-partenaire" className="text-accent hover:underline">
            Inscrivez-vous
          </Link>
        </p>
      </Card>
    </div>
  );
}
